import { useTranslation } from 'react-i18next';

import Button from 'components/library/Button/Button';
import styles from '../Modal.module.css';
import stylesModal from './ErrorCreateModal.module.css';
import { domains } from 'global';
import type { ConfigState } from 'services/store/features/Config/types';

interface Props {
  config: ConfigState;
}

export default function ErrorCreateModal({
  config,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.bodyModal}>
      <div>
        <h1 className={stylesModal.icon}><span className={`${stylesModal.materialIcons} material-icons`}>cancel</span></h1>
      </div>
      <h3>{t('modal.errorTitle')}</h3>
      <p className={`${styles.text}`}>{t('modal.errorDescription')}</p>
      <p className={`${styles.text}`}>{t('modal.errorDescriptionSecond')}</p>
      <Button
        className={styles.button}
        variant="fill"
        type="secondary"
        label={t('modal.errorButton')}
        onButtonClick={() => document.location.assign(`${domains.auth}/create-account?auto_login=2&redirect=${window.location.origin}%3Fmodal=3`)}
      />
      <p className={`${styles.text} ${styles.font14}`}>
        {t('modal.successHelper')}
        &nbsp;
        <Button
          className={styles.ghostButton}
          variant="ghost"
          type="secondary"
          label={t('navigation.takeRdv')}
          onButtonClick={() => window.open(config.calendly)}
        />
      </p>
    </div>
  );
}
